import { render, staticRenderFns } from "./Notruf.vue?vue&type=template&id=ddf423c6"
import script from "./Notruf.vue?vue&type=script&lang=ts"
export * from "./Notruf.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports